document.addEventListener("teeinblue-event-component-injected", function () {
  const btnAtc = document.querySelector(
    ".teeinblue-enabled .t4s-product-form__buttons button.t4s-product-form__submit"
  );
  const qtt = document.querySelector("#tee-artwork-form .tee-btn--preview");
  if (btnAtc && qtt) {
    btnAtc.addEventListener("click", () => {
      const loadingDiv = document.createElement("div");
      loadingDiv.textContent =
        "Your design is generating, please wait for about 3 seconds...";

      loadingDiv.style.padding = "10px";
      loadingDiv.style.marginTop = "10px";
      loadingDiv.style.marginBottom = "10px";
      loadingDiv.style.backgroundColor = "#f0f0f0";
      loadingDiv.style.border = "1px solid #ccc";
      loadingDiv.style.textAlign = "center";

      qtt.parentNode.insertBefore(loadingDiv, qtt.nextSibling);

      setTimeout(() => {
        loadingDiv.remove();
      }, 10000);
    });

    console.log("btnAtc", qtt);
  }
});

document.addEventListener('teeinblue-event-component-injected', function() {

  const submitButton = document.querySelector('.t4s-product-form__buttons button.t4s-product-form__submit');
  if (submitButton) {
      submitButton.addEventListener('mousedown', handleButtonClick);
  }

  document.querySelectorAll(".tee-btn--preview").forEach((button) => {
    button.addEventListener("click", () => {
      const atcButton = document.querySelector('.tee-btn--atc');
      if (atcButton) {
          atcButton.addEventListener('mousedown', handleButtonClick);
      }
    });
  });
  
  function handleButtonClick() {
    var checkInterval = setInterval(function() {
        var form = document.getElementById('tee-artwork-form');
        var requiredFields = form.querySelectorAll('.tee-required');
        if (requiredFields.length > 0) {
            clearInterval(checkInterval);
            requiredFields[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    }, 500);
  
    setTimeout(function() {clearInterval(checkInterval);}, 1000);
  }
    
    
})